import { render, staticRenderFns } from "./StockInOut.vue?vue&type=template&id=4d801206&"
import script from "./StockInOut.vue?vue&type=script&lang=js&"
export * from "./StockInOut.vue?vue&type=script&lang=js&"
import style0 from "./StockInOut.vue?vue&type=style&index=0&id=4d801206&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports